<template>
  <div class="container-fluid">
    <devoir-de-conseil
      v-if="page === 'devoir-de-conseil'"
      @goto="goto($event)"
    />

    <tarificateur-vigeo
      v-if="page === 'tarificateur-vigeo'"
      @goto="goto($event)"
    />

    <tarificateur-sante
      v-if="page === 'tarificateur-sante'"
      @goto="goto($event)"
    />

    <souscription-vigeo
      v-if="page === 'souscription-vigeo'"
      @goto="goto($event)"
    />

    <souscription-sante
      v-if="page === 'souscription-sante'"
      @goto="goto($event)"
    />

    <recapitulatif-sante
      v-if="page === 'recapitulatif-sante'"
      @goto="goto($event)"
    />

    <recapitulatif-vigeo
      v-if="page === 'recapitulatif-vigeo'"
      @goto="goto($event)"
    />
  </div>
  <modals-container />
</template>

<script>
import { ref, onBeforeUnmount } from 'vue'
import DevoirDeConseil from 'src/modules/devoir-de-conseil/pages/DevoirDeConseil'
import TarificateurVigeo from "src/modules/tarificateur/pages/TarificateurVigeo";
import TarificateurSante from "src/modules/tarificateur/pages/TarificateurSante";
import SouscriptionVigeo from "src/modules/souscription/pages/SouscriptionVigeo";
import SouscriptionSante from "src/modules/souscription/pages/SouscriptionSante";
import RecapitulatifSante from "src/modules/recapitulatif/page/RecapitulatifSante";
import RecapitulatifVigeo from "src/modules/recapitulatif/page/RecapitulatifVigeo";

export default {
  name: 'App',
  components: {
    DevoirDeConseil,
    SouscriptionVigeo,
    SouscriptionSante,
    TarificateurSante,
    TarificateurVigeo,
    RecapitulatifSante,
    RecapitulatifVigeo
  },
  setup() {
    // Page par défaut pour les dev
    const defaultPage = 'devoir-de-conseil'
    // const defaultPage = 'tarificateur-vigeo'
    // const defaultPage =  'souscription-vigeo'
    // const defaultPage = 'tarificateur-sante'
    // const defaultPage =  'souscription-sante'
    // const defaultPage =  'recapitulatif-sante'

    // On récupère la page demandée
    const initialState = window.__INITIAL_STATE__ || {}
    const page = ref(initialState.page ?? defaultPage)

    const goto = (redirection) => {
      console.debug('goto', redirection)
      page.value = redirection
    }

    /**
     * Comme on est obligé d'utiliser les Iframes et qu'elles ne sont pas dans le même sous-domaine
     * Il faut envoyer un message indiquant la taille de la page actuelle pour que l'on puisse fixer correctement la
     * taille de l'iframe
     */
    const iframeHeightNotify = () => {
      // console.debug('iframeHeightNotify')
      const msg = {
        height: document.getElementById("app").scrollHeight
      }
      window.parent.postMessage(msg, '*')
      // console.debug('iframeHeightNotify', document.getElementById("app").scrollHeight)
    }

    const timer = setInterval(iframeHeightNotify, 300)

    onBeforeUnmount(() => {
      clearInterval(timer);
    })

    return {
      page,
      goto,
      iframeHeightNotify,
      timer
    }
  }
}
</script>

<style lang="scss" scoped>
#app {

}
</style>
